import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

import {
  savetrainingcontent_thunk,
  update_content_template_thunk,
} from "../template-master/FlnTemplate.Thunk";

import { upload_file_to_s3, delete_file_from_s3 } from "../../components/S3";
import Loader from "../../components/Loader";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
// Sun Editor
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { EditorOptions, handleEditorPaste, ensureContentSpacing } from "../../components/EditorOptions";
import Carousel from "react-material-ui-carousel";

// MUI
import { Transition } from "../../components/Transition";
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  TextField,
  Toolbar,
  Typography,
  Modal,
  CircularProgress,
  Paper,
} from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ImageIcon from "@mui/icons-material/Image";
import CloseIcon from "@mui/icons-material/Close";
import VideoCameraFrontIcon from "@mui/icons-material/VideoCameraFront";
import AddLinkIcon from "@mui/icons-material/AddLink";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import SaveIcon from "@mui/icons-material/Save";
import api from "../../api/api";
import { getMediaUrl } from "../../utils/mediaUtils";
import { toast } from "react-toastify";
import { getAllContents } from "../FlnActivity/FlnActivity.Thunk";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { deleteFileFromDB, UploadFileToAzureDB } from "../../components/Azure";
import BurstModeTwoToneIcon from "@mui/icons-material/BurstModeTwoTone";
import YouTubeIcon from "@mui/icons-material/YouTube";
function FlnTemplate({
  open,
  params,
  onClose,
  topic_select_onchange,
  setContents,
}) {
  const navigate = useNavigate();
  // ////console.log("contentData", params.contentData[0]);
  // -------------------------- Editor -------------------------
  //console.log("params: ", params);
  const editorOnClosee = () => {
    setStack([]);
    onClose();
    getAllContents({ topicId: params.topicId })
      .then((res) => {
        // console.log("getApiCalled");
        if (res.status === 200) {
          setContents(Array.isArray(res.data) ? res.data : []);
          setImageName("");
          const fileInput = document.getElementById("fileInput");
          if (fileInput) {
            fileInput.value = "";
          }
          // setImageUrl(uploadResults[0]);
          setSelectedImage(null);
          close_media_dialog();
          setMediaUploading(false);
        } else {
          console.log("Status received----------->", res.status);
          setSelectedImage(null);
          close_media_dialog();
          setMediaUploading(false);
        }
      })
      .catch((err) => {
        if (err.response && err.response.status === 413) {
          toast.error("The file is too large to upload");
          console.error("The error is:", err);
          setSelectedImage(null);
          close_media_dialog();
          setMediaUploading(false);
        } else {
          console.error("Error fetching modules:", err);
          setSelectedImage(null);
          close_media_dialog();
          setMediaUploading(false);
        }
      });
  };

  const [showLinkDialog, setShowLinkDialog] = useState(false);
  const [linkUrl, setLinkUrl] = useState("");
  const [linkText, setLinkText] = useState("");
  const [openPreview, setOpenPreview] = useState(false);
  const [mediaUploading, setMediaUploading] = useState(false);
  const [progress, setProgress] = useState(0);
  const [program, setProgram] = useState(null);
  const [youtubeFetching, setYoutubeFetching] = useState(false);
  const [linkAdding, setLinkAdding] = useState(false);
  const [finalSaving, setFinalSaving] = useState(false);

  console.log("params-------------->", params);

  const openLinkDialog = () => {
    setShowLinkDialog(true);
  };
  const closeLinkDialog = () => {
    setShowLinkDialog(false);
    setLinkUrl("");
    setLinkText("");
  };

  const UrlAdded = (e) => {
    setYoutubeFetching(true);
    setLinkUrl(e.target.value);
    setTimeout(() => {
      setYoutubeFetching(false);
    }, 400);
  };

  const addLinkToStack = () => {
    if (!linkUrl || linkUrl.trim() === "") {
      toast.error("Please add a YouTube link!");
    } else if (linkUrl.startsWith("https://youtu.be/")) {
      setLinkAdding(true);
      const newItem = {
        type: "youtube",
        label: linkText,
        value: linkUrl.split("/")[3],
      };
      setStack((prevStack) => [...prevStack, newItem]);
      setTimeout(() => {
        setLinkAdding(false);
        closeLinkDialog();
      }, 600);
    } else if (linkUrl.startsWith("https://www.youtube.com/watch?v=")) {
      setLinkAdding(true);
      const newItem = {
        type: "youtube",
        label: linkText,
        value: linkUrl.split("/")[3].replace("watch?v=", "").slice(0, 11),
      };
      setStack((prevStack) => [...prevStack, newItem]);
      setTimeout(() => {
        setLinkAdding(false);
        closeLinkDialog();
      }, 600);
    } else {
      toast.error("Please add only YouTube link!");
    }
  };
  // -----------------------------------------------------------

  const [stack, setStack] = useState([]);
  const [label, setLabel] = useState("");
  const [thumbnail, setThumbnail] = useState("");
  const [submitAction, setSubmitAction] = useState("save");
  const [fileUrl, setFileUrl] = useState("");
  useEffect(() => {
    setStack(Array.isArray(params.contentData) ? params.contentData : []);
    setSubmitAction(params.operation ? params.operation : "save");
  }, [params]);

  // -------------------------- Text ----------------------------
  const [operation, setOperation] = useState("save"); // "save"."edit"
  const [index, setIndex] = useState(-1);
  const [showTextDialog, setShowTextDialog] = React.useState(false);
  const open_text_dialog = () => {
    setShowTextDialog(true);
  };
  const close_text_dialog = () => {
    setLabel("");
    setEditor1Content("");
    setShowTextDialog(false);
  };
  const [editor1Content, setEditor1Content] = useState("");
  const texteditor_on_change = (content) => {
    setEditor1Content(content);
  };

  function removeHtmlTags(input) {
    const doc = new DOMParser().parseFromString(input, "text/html");
    return doc.body.textContent || "";
  }

  const add_text_to_stack = () => {
    // if (label.trim() === "") {
    //   setAlertTitle("Add Label");
    //   setAlertText("Please add a label to this content");
    //   setShowAlert(true);
    // } else {
    const formattedContent = ensureContentSpacing(editor1Content);
    const newItem = {
      type: "text",
      label,
      thumbnail,
      value: formattedContent,
    };
    if (operation === "save") {
      setStack((prevStack) => [...prevStack, newItem]);
      console.log("stack 180---------------->", stack);
    } else if (operation === "edit") {
      const updatedStack = stack.map((obj, i) => {
        if (i === index) return { ...obj, label, value: formattedContent };
        return obj;
      });
      setStack(updatedStack);
      setOperation("save");
      setIndex(-1);
    }
    ////console.log("--operation: ", operation, "    stack: ", stack);
    close_text_dialog();
    // }
  };
  // --------------------------------------------------------------

  // -------------------------- Media -----------------------------
  const mediaRef = useRef();
  const [showMediaDialog, setShowMediaDialog] = useState(false);
  const [mediaType, setMediaType] = useState("");
  const open_media_dialog = (type, fileType) => {
    setMediaType(type);
    setShowMediaDialog(true);
    setSelectedFileType(fileType);
  };

  //*-------------------Preview logic--------------------------------
  const openPreviewBox = () => {
    setOpenPreview(true);
  };

  const closePreviewBox = () => {
    setOpenPreview(false);
  };
  const close_media_dialog = () => {
    setLabel("");
    // mediaRef.current.value = null;
    setShowMediaDialog(false);
    setMyFile("");
    setSelectedImage(null);
    setImageName("");
    setFileExtensionType("");
    setMediaType("");
    setThumb("");
    setThumbnailFile(null);
    setThumbName("");
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.value = "";
    }
    const thumbInput = document.getElementById("thumbInput");
    if (thumbInput) {
      thumbInput.value = "";
    }
  };

  const [file, setFile] = useState(null);
  const media_file_on_change = (e) => {
    setFile(e.target.files[0]);
  };

  //-------------------Thumbnail Logics------------------------

  const [selectedFileType, setSelectedFileType] = useState(null);

  const videoElemRef = useRef();

  // const thumb_file_on_change = (e) => {
  //   // setFile(e.target.files[0]);/
  //   const selectedThumb = e.target.files[0];
  //   if (selectedThumb && selectedThumb.size <= 20 * 1024 * 1024) {
  //     // File size is within the limit, set it in the state
  //     setThumb(selectedThumb);
  //   } else {
  //     // File size exceeds the limit, show a toast error or alert
  //     toast.error("File size should be less than 20MB");
  //     setThumb(null); // Clear the selected file
  //   }
  // };

  const video_file_on_change = (e) => {
    const selectedVideoFile = e.target.files[0];
    if (selectedVideoFile && selectedVideoFile.size <= 100 * 1024 * 1024) {
      // Video file size is within the limit, set it in the state
      setFile(selectedVideoFile);
      if (mediaType === "video/*") {
        setSelectedFileType("video"); // Set the file type to "video"
      } else if (mediaType === "audio/*") {
        setSelectedFileType("audio"); // Set the file type to "video"
      } else if (mediaType === "image/*") {
        setSelectedFileType("image"); // Set the file type to "video"
      }
    } else {
      // Video file size exceeds the limit, show a toast error or alert
      toast.error("Video file size should be less than 100MB");
      setFile(null); // Clear the selected file
      setSelectedFileType(null); // Clear the selected file type
    }
  };

  ////console.log("stack--------------------->", stack);
  ////console.log("mediaType---------------->", mediaType);
  //------------------------------------------------------------

  // ----------------- Add / Edit / Delete Stack ------------------
  const add_media_to_stack = async () => {
    // if (mediaType === "video/*" && selectedImage && !thumb) {
    //   toast.error("Please choose a thumbnail for the video !");
    // } else if (mediaType === "video/*" && thumb && !selectedImage) {
    //   toast.error("Please choose a video !");
    // } else if (mediaType === "video/*" && !selectedImage && !thumb) {
    //   toast.error("Please choose a video and a thumbnail for it !");
    // } else {
    //   setMediaUploading(true);
    //   await handleFileUpload(); //
    //   await handleThumbnailUpload();

    //   const newItem = {
    //     type: selectedFileType,
    //     label,
    //     value: imageName,
    //     thumbnail: thumbName ? thumbName : "",
    //   };

    //   setStack((prevStack) => [...prevStack, newItem]);
    //   close_media_dialog();
    //   setMediaUploading(false);
    //   const fileInput = document.getElementById("fileInput");
    //   if (fileInput) {
    //     fileInput.value = "";
    //   }
    //   clearInputStates(); // Clear input states here
    // }

    if (mediaType === "video/*" && !thumb && selectedImage) {
      toast.error("Please choose a thumbnail for the video !");
    } else if (mediaType === "video/*" && !selectedImage && thumb) {
      toast.error("Please choose a video !");
    } else if (mediaType === "video/*" && !selectedImage && !thumb) {
      toast.error("Please choose a video and a thumbnail for it !");
    }
    // else if (mediaType === "hotspot/*" && savedValues?.length === 0) {
    //   toast.error("Please choose Image and spots !");
    // }
    else if (mediaType === "slider/*" && sliderImages?.length === 0) {
      toast.error("Please choose Image for slider !");
    } else {
      // console.log("media---->", mediaType, savedValues);
      setMediaUploading(true);
      console.log(
        `Selected Image name--> ${imageName}  and Image file--${selectedImage}`
      );
      console.log(
        `Selected Image name--> ${thumbName}  and Image file--${thumb}`
      );

      let uploadResults = [];
      if (mediaType === "slider/*") {
        for (let i = 0; i < sliderImages.length; i++) {
          const { file } = sliderImages[i];
          const fileExtension = file.name.split(".").pop().toLowerCase(); // Define fileExtension
          const newFileName = `training_${program}_${new Date().getTime()}.${fileExtension}`;

          const uploadResult = await UploadFileToAzureDB(file, newFileName); // Use newFileName

          uploadResults.push(uploadResult.url);
        }
      } else {
        const uploadResult = await UploadFileToAzureDB(
          selectedImage,
          imageName
        );
        uploadResults.push(uploadResult.url);
      }

      console.log("uploadResults-->", uploadResults);

      let newItem;

      // if
      // (selectedFileType === "hotspot") {
      //   newItem = {
      //     label,
      //     value: savedValues,
      //     type: selectedFileType,
      //     thumbnail: imageName,
      //   };
      // } else
      if (selectedFileType === "slider") {
        newItem = {
          label,
          value: uploadResults,
          type: selectedFileType,
          thumbnail: "",
        };
      } else {
        let thumbUrl = "";
        if (thumb) {
          thumbUrl = await handleThumbnailUpload();
        }
        newItem = {
          type: selectedFileType,
          label,
          value: uploadResults[0] || imageName,
          thumbnail: thumbUrl ? thumbUrl : thumbName ? thumbName : "",
        };
      }

      console.log("newItem---->", newItem);
      setStack((prevStack) => [...prevStack, newItem]);
      console.log("stack 383------------->", stack);
      // close_media_dialog();
      clearInputStates();
      getAllContents({ topicId: params.topicId })
        .then((res) => {
          // console.log("getApiCalled");
          if (res.status === 200) {
            setContents(Array.isArray(res.data) ? res.data : []);
            setImageName("");
            const fileInput = document.getElementById("fileInput");
            if (fileInput) {
              fileInput.value = "";
            }
            // setImageUrl(uploadResults[0]);
            setSelectedImage(null);
            close_media_dialog();
            setMediaUploading(false);
          } else {
            console.log("Status received----------->", res.status);
            setSelectedImage(null);
            close_media_dialog();
            setMediaUploading(false);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 413) {
            toast.error("The file is too large to upload");
            console.error("The error is:", err);
            setSelectedImage(null);
            close_media_dialog();
            setMediaUploading(false);
          } else {
            console.error("Error fetching modules:", err);
            setSelectedImage(null);
            close_media_dialog();
            setMediaUploading(false);
          }
        });
    }
  };

  const edit_stack = (ele, index) => {
    setIndex(index);
    setOperation("edit");
    setLabel(ele.label);
    setEditor1Content(ele.value);

    setShowTextDialog(true);
  };
  const edit_stack_media = (ele, index) => {
    setIndex(index);
    setOperation("edit");
    setLabel(ele.label);
    // setEditor1Content(ele.value);
    setShowMediaDialog(true);
  };

  const delete_stack = (type, ele, index) => {
    const updatedStack = stack.filter((_, i) => i !== index);
    setStack(updatedStack);

    const deleteFile = (fileUrl) => {
      try {
        // Attempt to create a URL object from the fileUrl
        const parsedUrl = new URL(fileUrl);
        const path = parsedUrl.pathname;
        const segments = path.split("/");
        const filename = segments[segments.length - 1];

        // Log the filename to be deleted
        console.log("Deleting file:", filename);

        // Call your function to delete the file from the database
        deleteFileFromDB(fileUrl);
        setShowLoader(true);
        setProgress(0);
      } catch (error) {
        // Handle the error if the URL is invalid
        console.error("Invalid URL:", fileUrl, error);
        // Optionally, you can show a notification or alert to the user
      }
    };

    if (type === "media") {
      deleteFile(ele.thumbnail);
    } else if (ele.type === "slider") {
      ele.value.forEach(deleteFile);
    } else {
      deleteFile(ele.value);
    }
  };

  const save_content = () => {
    // ////console.log("-->Save button click >> submitAction: ", submitAction, "    program: ", program, "    params: ", params, "    statck: ", stack);
    ////console.log("savecontent --------------->", save_content);
    if (stack.length > 0) {
      // if (program === "21st") {
      if (submitAction === "save") save_content_post();
      else if (submitAction === "update") update_content();
      // }
    } else {
      setAlertTitle("Error");
      setAlertText("[Code: 1005] Nothing to save");
      toast.error("Nothing to save");
    }
  };

  //*---------To get the url that is sent--------------------
  const handleFileUpload = async () => {
    try {
      console.log(
        `Selected Image name--> ${imageName}  and Image file--${selectedImage}`
      );
      const result = await UploadFileToAzureDB(selectedImage, imageName);
      // setFileUrl(result.url);
    } catch (error) {
      if (error.response && error.response.status === 413) {
        toast.error("The file is too large to upload");
        console.error("The error is:", error);
      } else {
        console.error("Error fetching modules:", error);
      }
    }
  };

  //*---------To get the url for the thumbnail is sent--------------------
  const handleThumbnailUpload = async () => {
    try {
      console.log(
        `Selected thumbnail name--> ${thumbName}  and thumbnail file--${thumb}`
      );
      const result = await UploadFileToAzureDB(thumb, thumbName);
      return result?.url || thumbName;
    } catch (error) {
      if (error.response && error.response.status === 413) {
        toast.error("The file is too large to upload");
        console.error("The error is:", error);
      } else {
        console.error("Error fetching modules:", error);
      }
    }
  };

  // ----------------------- Save Contennt ------------------------
  const save_content_post = () => {
    setFinalSaving(true);
    if (stack.length > 0) {
      const processedStack = stack.map((item) =>
        item.type === "text" && item.value
          ? { ...item, value: ensureContentSpacing(item.value) }
          : item
      );
      const body = { topicId: params.topicId, contentData: processedStack };
      savetrainingcontent_thunk(body).then((data) => {
        if (data.status === "success") {
          setAlertTitle("Error");
          setLabel("");
          setAlertText("Content save failed");
          setStack([]);
          setFinalSaving(false);
          setShowAlert(true);
          setFileUrl("");
          setOpenPreview(false);
        } else {
          setAlertTitle("Success");
          setFinalSaving(false);
          setAlertText("Content saved successfully");
          setShowAlert(true);
          setFileUrl("");
          setOpenPreview(false);
        }
      });
    } else alert("Nothing to save");
    setFileUrl("");
    setFinalSaving(false);
    setOpenPreview(false);
  };

  const update_content = () => {
    setFinalSaving(true);
    if (stack?.length > 0) {
      const processedStack = stack.map((item) =>
        item.type === "text" && item.value
          ? { ...item, value: ensureContentSpacing(item.value) }
          : item
      );
      const body = {
        topicId: params?.topicId,
        contentData: processedStack,
      };
      //console.log("update content", body);
      update_content_template_thunk(body).then((data) => {
        if (data?.status === 200) {
          setAlertTitle("Success");
          setFinalSaving(false);
          setAlertText("Content update successfully");
          setLabel("");
          setStack([]);
          setShowAlert(true);
          setFileUrl("");
          setOpenPreview(false);
        } else {
          setAlertTitle("Error");
          setAlertText("Content save failed");
          setFinalSaving(false);
          setShowAlert(true);
          setFileUrl("");
          setOpenPreview(false);
        }
      });
    } else alert("Nothing to save");
    setFileUrl("");
    setFinalSaving(false);
    setOpenPreview(false);
  };

  //Content rearrangement
  const change_stack_position = (index1, index2) => {
    if (
      index1 < 0 ||
      index2 < 0 ||
      index1 >= stack.length ||
      index2 >= stack.length
    )
      return; // Ensure indices are within bounds

    setStack((prevStack) => {
      const newData = [...prevStack];
      // Swap the two entire objects
      [newData[index1], newData[index2]] = [newData[index2], newData[index1]];
      return newData;
    });
  };
  // ---------------------------------------------------------------

  // ------------------------ Alert -------------------------------
  const [showAlert, setShowAlert] = useState(false);
  const [alertTitle, setAlertTitle] = useState("");
  const [alertText, setAlertText] = useState("");
  const open_alert = () => {
    setShowAlert(true);
  };
  const close_alert = () => {
    // editorOnClose();
    setShowAlert(false);
    onClose();
    getAllContents(params)
      .then((res) => {
        // console.log("reposnse", res);
        setContents(Array.isArray(res?.data) ? res.data : []);
      })
      .catch((error) => {
        //console.log(error);
      });
  };
  // ---------------------------------------------------------------

  // ------------------------ Loader -------------------------------
  const [showLoader, setShowLoader] = useState(false);
  // const [progress, setProgress] = useState(0);
  // ---------------------------------------------------------------
  const [fileExtensionType, setFileExtensionType] = useState("");
  const [myFile, setMyFile] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageName, setImageName] = useState("");
  const [sliderImages, setSliderImages] = useState([]);

  // The upload server sniffs the file's actual bytes and rejects it with a 415 when
  // they don't match the declared type/extension (renamed screenshots, HEIC exported
  // as .jpg, WebP saved as .png, etc). Re-encoding through a canvas guarantees the
  // uploaded bytes always genuinely match the declared type: PNG stays PNG (keeps
  // transparency), everything else becomes JPEG.
  const reencodeImageFile = (img, fileType) =>
    new Promise((resolve) => {
      const mimeType = fileType === "image/png" ? "image/png" : "image/jpeg";
      const extension = mimeType === "image/png" ? "png" : "jpg";
      const canvas = document.createElement("canvas");
      canvas.width = img.naturalWidth || img.width;
      canvas.height = img.naturalHeight || img.height;
      canvas.getContext("2d").drawImage(img, 0, 0);
      canvas.toBlob(
        (blob) =>
          resolve({
            blob,
            extension,
            mimeType,
            dataUrl: canvas.toDataURL(mimeType),
          }),
        mimeType,
        0.92
      );
    });

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const maxHeight = 563;
    const maxWidth = 850;

    if (file) {
      const fileType = file.type;

      if (selectedFileType === "image" && file.size > 2097152) {
        toast.error("File size exceeds the maximum allowed (2 MB)");
        return;
      } else if (selectedFileType === "audio" && file.size > 5948300) {
        toast.error("File size exceeds the maximum allowed (4 MB)");
        return;
      } else if (selectedFileType === "video" && file.size > 20971520) {
        toast.error("File size exceeds the maximum allowed (20 MB)");
        return;
      }

      if (fileType.startsWith("video/")) {
        setFileExtensionType("mp4");
        setImageName(`studAct_${new Date().getTime()}.mp4`);
        setSelectedFileType("video");

        const videoUrl = URL.createObjectURL(file); // Create a URL for the video file
        setMyFile(videoUrl); // Set the file URL
        setSelectedImage(file); // Set the selected video file
      } else if (fileType.startsWith("audio/")) {
        setFileExtensionType("mp3");
        setImageName(`studAct_${new Date().getTime()}.mp3`);
        setSelectedFileType("audio");
        setMyFile(URL.createObjectURL(file)); // Set the audio file URL
        setSelectedImage(file); // Set the selected audio file
      } else if (fileType.startsWith("image/")) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = async () => {
            const { width, height } = img;

            if (width > maxWidth || height > maxHeight) {
              toast.error("Maximum height and width exceeded");
              return;
            }

            const { blob, extension, mimeType, dataUrl } =
              await reencodeImageFile(img, fileType);
            if (!blob) {
              toast.error(
                "Could not process this image. Please try a different file."
              );
              return;
            }

            const newFileName = `studAct_${program}_${new Date().getTime()}.${extension}`;
            setFileExtensionType(extension);
            setImageName(newFileName);
            setSelectedFileType(
              selectedFileType === "image"
                ? "image"
                : mediaType === "slider/*"
                  ? "slider"
                  : "image"
            );

            setMyFile(dataUrl); // Set the base64 URL for the image
            setSelectedImage(
              new File([blob], newFileName, { type: mimeType })
            ); // Set the re-encoded image file
          };
        };

        reader.readAsDataURL(file);
      } else {
        console.error("Unsupported file type");
        return;
      }
    }
  };

  const handleSliderChange = (e) => {
    const files = Array.from(e.target.files);
    const maxImages = 7;
    const maxHeight = 563;
    const maxWidth = 850;

    if (sliderImages.length + files.length > maxImages) {
      toast.error(`You can only upload a maximum of ${maxImages} images`);
      return;
    }

    const newImagePreviews = [...sliderImages];
    let valid = true;

    files.forEach((file, index) => {
      const fileType = file.type;

      if (!fileType.startsWith("image/")) {
        toast.error("Unsupported file type");
        valid = false;
        return;
      }

      const reader = new FileReader();

      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target.result;

        img.onload = async () => {
          const { width, height } = img;

          if (width > maxWidth || height > maxHeight) {
            toast.error("Maximum height and width exceeded");
            valid = false;
            return;
          }

          const { blob, extension, mimeType, dataUrl } =
            await reencodeImageFile(img, fileType);
          if (!blob) {
            toast.error(
              "Could not process this image. Please try a different file."
            );
            valid = false;
            return;
          }

          const newFileName = `slider_${Date.now()}_${index}.${extension}`;
          newImagePreviews.push({
            src: dataUrl,
            file: new File([blob], newFileName, { type: mimeType }),
          });

          if (index === files.length - 1 && valid) {
            setSliderImages(newImagePreviews);
          }
        };
      };

      reader.readAsDataURL(file);
    });
  };

  const handleRemoveImage = (index) => {
    setSliderImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  //*----------States to handle thumbnail logic-------------------
  const [thumb, setThumb] = useState("");
  const [thumbName, setThumbName] = useState("");
  const [thumbnailFile, setThumbnailFile] = useState(null);

  //*--------------to add thumbnail-----------------------
  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    const maxHeight = 752;
    const maxWidth = 1352;

    if (file) {
      const fileType = file.type;

      if (selectedFileType === "image" && file.size > 2097152) {
        toast.error("File size exceeds the maximum allowed (2 MB)");
        return;
      }

      if (fileType.startsWith("image/")) {
        const reader = new FileReader();

        reader.onload = (e) => {
          const img = new Image();
          img.src = e.target.result;

          img.onload = async () => {
            const { width, height } = img;

            if (width > maxWidth || height > maxHeight) {
              toast.error("Maximum height and width exceeded");
              return;
            }

            const { blob, extension, mimeType, dataUrl } =
              await reencodeImageFile(img, fileType);
            if (!blob) {
              toast.error(
                "Could not process this image. Please try a different file."
              );
              return;
            }

            const newThumbName = `studAct_thumbnail_${new Date().getTime()}.${extension}`;
            setFileExtensionType(extension);
            setThumbName(newThumbName);
            setThumbnailFile(dataUrl); // Set the base64 URL for the image
            setThumb(new File([blob], newThumbName, { type: mimeType })); // Set the re-encoded image file
          };
        };

        reader.readAsDataURL(file);
      } else {
        console.error("Unsupported file type");
        return;
      }
    }
  };

  const clearInputStates = () => {
    setLabel("");
    setThumbnail("");
    // setSelectedFile(null);
    // setSelectedFileNameWithExtension(null);
    // setSelectedFileNameWithoutExtension(null);
    // setSelectedFileExtension(null);
    setSelectedFileType(null);
    // setSelectedFileSize(null);
    setSelectedImage(null);
    setSliderImages([]);
    setMyFile("");
    const fileInput = document.getElementById("fileInput");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  function getYouTubeId(url) {
    let videoId = "";
    const regExp = /^.*(youtu.be\/|v\/|e\/|u\/\w+\/|embed\/|v=)([^#\&\?]*).*/;
    const match = url.match(regExp);
    if (match && match[2].length === 11) {
      videoId = match[2];
    }
    return videoId;
  }

  console.log("stack------------->", stack);
  console.log("imagre name------------->:", imageName);

  return (
    <>
      <Dialog
        fullScreen
        open={open}
        onClose={editorOnClosee}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            {/* <IconButton edge="start" color="inherit" onClick={editorOnClose} aria-label="close">
              <CloseIcon />
            </IconButton> */}
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Content Editor
            </Typography>

            <Button autoFocus color="inherit" onClick={editorOnClosee}>
              <CloseIcon />
            </Button>
          </Toolbar>
        </AppBar>
        <div>
          <div className="add_element_menu">
            <Button onClick={open_text_dialog}>
              <AssignmentIcon />
            </Button>
            <Button onClick={() => open_media_dialog("image/*")}>
              <ImageIcon />
            </Button>
            <Button onClick={() => open_media_dialog("slider/*", "slider")}>
              <BurstModeTwoToneIcon />
            </Button>
            <Button onClick={() => open_media_dialog("audio/*")}>
              <VolumeUpIcon />
            </Button>
            <Button onClick={() => open_media_dialog("video/*")}>
              <VideoCameraFrontIcon />
            </Button>
            {/* <Button onClick={openPreviewBox}>Preview</Button> */}
            <Button onClick={openLinkDialog}>
              <YouTubeIcon />
            </Button>
            <Button onClick={openPreviewBox}>
              <SaveIcon />
            </Button>
          </div>

          {/* Preview */}
          <div className="outer-preview">
            <div className="inner-preview">
              {stack.map((object, index) => (
                <div key={index} className="preview-card">
                  <div>
                    {object.type === "text" && (
                      <>
                        <div>
                          <Button
                            color="error"
                            onClick={() => delete_stack("text", object, index)}
                          >
                            <HighlightOffIcon />
                          </Button>
                          <Button onClick={() => edit_stack(object, index)}>
                            <DriveFileRenameOutlineIcon />
                          </Button>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index + 1)
                            }
                          >
                            <KeyboardArrowDownIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index - 1)
                            }
                          >
                            <KeyboardArrowUpIcon />
                          </IconButton>
                        </div>
                        {object.label}
                        <div
                          className="sun-editor-editable"
                          dangerouslySetInnerHTML={{
                            __html: object.value,
                          }}
                          style={{ wordWrap: "break-word", padding: 0 }}
                        ></div>
                      </>
                    )}

                    {object.type === "image" && (
                      <>
                        <div>
                          <Button
                            color="error"
                            onClick={() => delete_stack("media", object, index)}
                          >
                            <HighlightOffIcon />
                          </Button>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index + 1)
                            }
                          >
                            <KeyboardArrowDownIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index - 1)
                            }
                          >
                            <KeyboardArrowUpIcon />
                          </IconButton>
                        </div>
                        <div>
                          {object.label}
                          {object.value &&
                            object.type === "image" &&
                            submitAction === "save" ? (
                            <img
                              src={getMediaUrl(object.value)}
                              width="90%"
                              alt=""
                            />
                          ) : object.value &&
                            object.type === "image" &&
                            submitAction === "update" ? (
                            <img
                              src={
                                getMediaUrl(object.value)
                              }
                              width="90%"
                              alt=""
                            />
                          ) : null}
                        </div>
                      </>
                    )}
                    {object.type === "slider" && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <Button
                            color="error"
                            onClick={() => delete_stack("media", object, index)}
                          >
                            <HighlightOffIcon />
                          </Button>
                          <IconButton
                            aria-label="move down"
                            onClick={() =>
                              change_stack_position(index, index + 1)
                            }
                          >
                            <KeyboardArrowDownIcon />
                          </IconButton>
                          <IconButton
                            aria-label="move up"
                            onClick={() =>
                              change_stack_position(index, index - 1)
                            }
                          >
                            <KeyboardArrowUpIcon />
                          </IconButton>
                        </div>
                        <div style={{ marginTop: "10px" }}>
                          {object.label}
                          {Array.isArray(object.value) &&
                            object.type === "slider" &&
                            (submitAction === "save" ||
                              submitAction === "update") ? (
                            <Carousel
                              style={{
                                display: "block",
                                marginTop: "10px",
                              }}
                            >
                              {object.value.map((url, index) => (
                                <Paper
                                  key={index}
                                  style={{
                                    width: "100%",
                                    padding: "5px",
                                  }}
                                >
                                  <img
                                    src={getMediaUrl(url)}
                                    width="100%"
                                    alt=""
                                    style={{
                                      width: "100%",
                                      height: "auto",
                                      display: "block",
                                    }}
                                  />
                                </Paper>
                              ))}
                            </Carousel>
                          ) : null}
                        </div>
                      </>
                    )}

                    {object.type === "audio" && (
                      <>
                        <div>
                          <Button
                            color="error"
                            onClick={() => delete_stack("media", object, index)}
                          >
                            <HighlightOffIcon />
                          </Button>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index + 1)
                            }
                          >
                            <KeyboardArrowDownIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index - 1)
                            }
                          >
                            <KeyboardArrowUpIcon />
                          </IconButton>
                        </div>
                        <div>
                          {object.label}
                          {object.value &&
                            object.type === "audio" &&
                            submitAction === "save" ? (
                            <audio controls style={{ width: "90%" }}>
                              <source
                                src={getMediaUrl(object.value)}
                              />
                            </audio>
                          ) : object.value &&
                            object.type === "audio" &&
                            submitAction === "update" ? (
                            <audio controls style={{ width: "90%" }}>
                              <source
                                src={
                                  getMediaUrl(object.value)
                                }
                              />
                            </audio>
                          ) : null}
                        </div>
                      </>
                    )}

                    {object.type === "text-audio" && (
                      <>
                        <div>
                          <Button
                            color="error"
                            onClick={() => delete_stack("media", object, index)}
                          >
                            <HighlightOffIcon />
                          </Button>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index + 1)
                            }
                          >
                            <KeyboardArrowDownIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index - 1)
                            }
                          >
                            <KeyboardArrowUpIcon />
                          </IconButton>
                        </div>
                        <div>
                          {object.label}
                          {object.value &&
                            object.type === "text-audio" &&
                            submitAction === "save" ? (
                            <audio controls style={{ width: "90%" }}>
                              <source
                                src={getMediaUrl(object.value)}
                              />
                            </audio>
                          ) : object.value &&
                            object.type === "text-audio" &&
                            submitAction === "update" ? (
                            <audio controls style={{ width: "90%" }}>
                              <source
                                src={
                                  getMediaUrl(object.value)
                                }
                              />
                            </audio>
                          ) : null}
                        </div>
                      </>
                    )}

                    {object.type === "video" && (
                      <>
                        <div>
                          <Button
                            color="error"
                            onClick={() => delete_stack("media", object, index)}
                          >
                            <HighlightOffIcon />
                          </Button>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index + 1)
                            }
                          >
                            <KeyboardArrowDownIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index - 1)
                            }
                          >
                            <KeyboardArrowUpIcon />
                          </IconButton>
                        </div>
                        <div>
                          {object.label}
                          {object.thumbnail && (
                            <img
                              src={
                                getMediaUrl(object.thumbnail)
                              }
                              width="90%"
                              alt=""
                            />
                          )}
                        </div>
                        <div>
                          {object.label}
                          {object.value && (
                            <video key={object._id} controls width="98%">
                              <source
                                src={
                                  getMediaUrl(object.value)
                                }
                              />
                            </video>
                          )}
                        </div>
                      </>
                    )}

                    {object.type === "youtube" && (
                      <>
                        <div>
                          <Button
                            color="error"
                            onClick={() => delete_stack("text", object, index)}
                          >
                            <HighlightOffIcon />
                          </Button>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index + 1)
                            }
                          >
                            <KeyboardArrowDownIcon />
                          </IconButton>
                          <IconButton
                            aria-label="delete"
                            onClick={() =>
                              change_stack_position(index, index - 1)
                            }
                          >
                            <KeyboardArrowUpIcon />
                          </IconButton>
                        </div>
                        {object.type === "youtube" && (
                          <>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: object.label,
                              }}
                              style={{ wordWrap: "break-word" }}
                            ></div>
                            <div>
                              <iframe
                                title="YouTube Video"
                                width="300"
                                height="195"
                                src={`https://www.youtube.com/embed/${object.value}`}
                                frameborder="0"
                                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                allowfullscreen
                              ></iframe>
                            </div>
                          </>
                        )}
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <Modal open={openPreview} onClose={closePreviewBox}>
            <div
              style={{
                // position: "absolute",
                // top: 0,
                // left: 0,
                width: "100%", // Full width of the viewport
                height: "100%", // Full height of the viewport
                backgroundColor: "white", // You can customize the background color
                overflow: "auto", // Allow scrolling if the content exceeds the viewport
              }}
            >
              <div
                style={{
                  width: "26%",
                  border: "grey 0.4px solid",
                  marginLeft: "36%",
                  // display: "flex",
                  // flexDirection: "column",
                  // justifyContent: "center",
                  height: "77%",
                  overflow: "auto",
                  marginTop: "5%",
                }}
              >
                {stack.map((object, index) => (
                  <div
                    key={index}
                    style={{
                      padding: "5%",
                    }}
                  >
                    {object.label}
                    {object.type === "text" && (
                      <div
                        className="sun-editor-editable"
                        dangerouslySetInnerHTML={{
                          __html: object.value,
                        }}
                        style={{ wordWrap: "break-word", padding: 0 }}
                      ></div>
                    )}
                    <div style={{}}>
                      {object.value &&
                        object.type === "image" &&
                        submitAction === "save" ? (
                        <img
                          src={
                            getMediaUrl(object.value)
                          }
                          // width="50%"
                          alt=""
                        />
                      ) : object.value &&
                        object.type === "image" &&
                        submitAction === "update" ? (
                        <img
                          src={
                            getMediaUrl(object.value)
                          }
                          width="90%"
                          alt=""
                        />
                      ) : null}
                    </div>
                    {object.type === "audio" && submitAction === "save" ? (
                      <audio controls width="90%">
                        <source
                          src={
                            getMediaUrl(object.value)
                          }
                        />
                      </audio>
                    ) : object.type === "audio" && submitAction === "update" ? (
                      <audio controls width="90%">
                        <source
                          src={
                            getMediaUrl(object.value)
                          }
                        />
                      </audio>
                    ) : null}
                    {object.type === "video" && submitAction === "save" ? (
                      <div>
                        {object.type === "video" && object.thumbnail !== "" ? (
                          <>
                            <img
                              src={
                                getMediaUrl(object.thumbnail)
                              }
                              width="87%"
                              alt=""
                            />
                          </>
                        ) : null}
                        <video controls width="98%">
                          <source
                            src={
                              getMediaUrl(object.value)
                            }
                          />
                        </video>
                      </div>
                    ) : object.type === "video" && submitAction === "update" ? (
                      <div>
                        {object.type === "video" && object.thumbnail !== "" ? (
                          <>
                            <img
                              src={
                                getMediaUrl(object.thumbnail)
                              }
                              width="87%"
                              alt=""
                            />
                          </>
                        ) : null}
                        <video controls width="98%">
                          <source
                            src={
                              getMediaUrl(object.value)
                            }
                          />
                        </video>
                      </div>
                    ) : null}
                    {object.type === "youtube" && (
                      <>
                        {/* <div
                          dangerouslySetInnerHTML={{
                            __html: object.label,
                          }}
                          style={{ wordWrap: "break-word" }}
                        ></div> */}
                        <div>
                          <iframe
                            title="YouTube Video"
                            width="346"
                            height="195"
                            src={`https://www.youtube.com/embed/${object.value}`}
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                          ></iframe>
                        </div>
                      </>
                    )}
                    <div style={{}}>
                      {object.type === "slider" && submitAction === "save" ? (
                        <Carousel
                          style={{
                            display: "block",
                            marginTop: "10px",
                          }}
                        >
                          {object.value.map((url, index) => (
                            <Paper
                              key={index}
                              style={{
                                width: "100%",
                                padding: "5px",
                              }}
                            >
                              <img
                                src={getMediaUrl(url)}
                                width="100%"
                                alt=""
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  display: "block",
                                }}
                              />
                            </Paper>
                          ))}
                        </Carousel>
                      ) : Array.isArray(object.value) &&
                        object.type === "slider" &&
                        submitAction === "update" ? (
                        <Carousel
                          style={{
                            display: "block",
                            marginTop: "10px",
                          }}
                        >
                          {object.value.map((url, index) => (
                            <Paper
                              key={index}
                              style={{
                                width: "100%",
                                padding: "5px",
                              }}
                            >
                              <img
                                src={getMediaUrl(url)}
                                width="100%"
                                alt=""
                                style={{
                                  width: "100%",
                                  height: "auto",
                                  display: "block",
                                }}
                              />
                            </Paper>
                          ))}
                        </Carousel>
                      ) : null}
                    </div>
                  </div>
                ))}
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  width: "35%",
                  marginLeft: "64%",
                }}
              >
                <Button variant="contained" onClick={closePreviewBox}>
                  Close
                </Button>
                {finalSaving ? (
                  <div style={{}}>
                    <CircularProgress />
                  </div>
                ) : (
                  <Button variant="contained" onClick={save_content}>
                    Save
                  </Button>
                )}
              </div>
            </div>
          </Modal>

          {/* Text Dialog */}
          {/* <Dialog open={showTextDialog} onClose={close_text_dialog} keepMounted fullWidth={true} maxWidth="lg" TransitionComponent={Transition} aria-describedby="text-editor"> */}
          <Dialog
            open={showTextDialog}
            keepMounted
            fullWidth={true}
            maxWidth="lg"
            TransitionComponent={Transition}
            aria-describedby="text-editor"
          >
            <DialogTitle>{"Add Text Content"}</DialogTitle>
            <DialogContent>
              <TextField
                id="title"
                label="Label"
                name="label"
                value={label}
                onChange={(e) => setLabel(e.target.value)}
                size="small"
                autoComplete="label"
                margin="normal"
                required
                autoFocus
                fullWidth
              />
              <div>
                <SunEditor
                  height="200px"
                  setContents={editor1Content}
                  onChange={texteditor_on_change}
                  setOptions={EditorOptions}
                  onPaste={handleEditorPaste}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button onClick={close_text_dialog}>Cancel</Button>
              <Button onClick={add_text_to_stack} variant="contained">
                Add Content
              </Button>
            </DialogActions>
          </Dialog>

          {/* Media Dialog */}
          <Dialog
            open={showMediaDialog}
            keepMounted
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            aria-describedby="text-editor"
          >
            {mediaType === "slider/*" ? (
              <>
                <DialogTitle>{"Add Slider Images"}</DialogTitle>
                <DialogContent>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      document.getElementById("sliderFileInput").click()
                    }
                  >
                    Add
                  </Button>
                  <input
                    id="sliderFileInput"
                    type="file"
                    accept="image/*"
                    multiple
                    style={{ display: "none" }}
                    key={sliderImages?.length}
                    onChange={handleSliderChange}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      marginTop: "20px",
                    }}
                  >
                    {sliderImages.map((image, index) => (
                      <div
                        key={index}
                        style={{ margin: "10px", position: "relative" }}
                      >
                        <img
                          src={image.src}
                          alt={`Slider ${index}`}
                          width="100px"
                          style={{ display: "block" }}
                        />
                        <IconButton
                          color="inherit"
                          size="small"
                          onClick={() => handleRemoveImage(index)}
                          style={{
                            position: "absolute",
                            top: 0,
                            right: 0,
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </div>
                    ))}
                  </div>
                </DialogContent>
              </>
            ) : (
              <>
                {" "}
                <DialogTitle>{"Upload Media File"}</DialogTitle>
                <DialogContent>
                  <TextField
                    id="title"
                    label="Label"
                    name="label"
                    value={label}
                    onChange={(e) => setLabel(e.target.value)}
                    size="small"
                    autoComplete="label"
                    margin="normal"
                    required
                    autoFocus
                    fullWidth
                  />

                  {mediaType === "video/*" ? (
                    <div>
                      <h4>Add Thumbnail</h4>
                      <input
                        type="file"
                        accept={"image/*"}
                        // ref={inputFileRef}
                        id="thumbInput"
                        onChange={handleThumbnailChange}
                      />

                      {thumbnailFile ? (
                        <div>
                          <img
                            src={thumbnailFile}
                            alt="image"
                            style={{
                              height: "140px",
                              width: "60%",
                              marginTop: "40px",
                            }}
                          />
                        </div>
                      ) : null}

                      {selectedFileType === "image" ? (
                        <img
                          src={myFile}
                          alt="Uploaded File"
                          style={{
                            height: "250px",
                            width: "90%",
                            marginTop: "40px",
                          }}
                        />
                      ) : null}
                    </div>
                  ) : null}

                  <div style={{ marginTop: "15px", paddingBottom: "20px" }}>
                    <input
                      type="file"
                      accept={
                        mediaType === "audio/*" || mediaType === "text-audio/*"
                          ? "audio/*"
                          : mediaType === "slider/*"
                            ? "image/*"
                            : mediaType
                      }
                      id="fileInput"
                      onChange={handleFileChange}
                    />
                  </div>

                  {selectedFileType === "image" ? (
                    <img
                      src={myFile}
                      alt="Uploaded File"
                      style={{
                        height: "250px",
                        width: "90%",
                        marginTop: "40px",
                      }}
                    />
                  ) : selectedFileType === "audio" ||
                    selectedFileType === "text-audio" ? (
                    <audio
                      controls
                      src={myFile}
                      style={{ marginTop: "40px" }}
                    ></audio>
                  ) : selectedFileType === "video" ? (
                    <video
                      controls
                      src={myFile}
                      width={"90%"}
                      height={"250px"}
                      style={{ marginTop: "20px" }}
                    ></video>
                  ) : null}
                </DialogContent>
              </>
            )}
            <DialogActions>
              <Button onClick={close_media_dialog}>Cancel</Button>
              {mediaUploading ? (
                <div style={{}}>
                  <CircularProgress />
                </div>
              ) : (
                <Button onClick={add_media_to_stack} variant="contained">
                  Upload File
                </Button>
              )}
            </DialogActions>
          </Dialog>
          {/* Link Dialog */}
          <Dialog
            open={showLinkDialog}
            keepMounted
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            aria-describedby="link-editor"
          >
            <DialogTitle>{"Add URL"}</DialogTitle>
            <DialogContent>
              <TextField
                id="linkLabel"
                label="Link Label"
                name="linkLabel"
                value={linkText}
                onChange={(e) => setLinkText(e.target.value)}
                size="small"
                autoComplete="url"
                margin="normal"
                required
                fullWidth
              />
              <TextField
                id="linkUrl"
                label="URL"
                name="linkUrl"
                value={linkUrl}
                onChange={UrlAdded}
                size="small"
                autoComplete="url"
                margin="normal"
                required
                fullWidth
              />
            </DialogContent>
            {youtubeFetching ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </div>
            ) : linkUrl &&
              linkUrl.startsWith("https://www.youtube.com/watch?v=") ? (
              <div style={{ paddingLeft: "30px" }}>
                <iframe
                  title="YouTube Video"
                  width="346"
                  height="195"
                  src={`https://www.youtube.com/embed/${linkUrl
                    .split("/")[3]
                    .replace("watch?v=", "")
                    .slice(0, 11)}`}
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            ) : linkUrl && linkUrl.startsWith("https://youtu.be/") ? (
              <div style={{ paddingLeft: "30px" }}>
                <iframe
                  title="YouTube Video"
                  width="346"
                  height="195"
                  src={`https://www.youtube.com/embed/${linkUrl
                    .split("/")[3]
                    .slice(0, 11)}`}
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                ></iframe>
              </div>
            ) : null}
            <DialogActions>
              <Button onClick={closeLinkDialog}>Cancel</Button>
              {linkAdding ? (
                <div style={{}}>
                  <CircularProgress />
                </div>
              ) : (
                <Button onClick={addLinkToStack} variant="contained">
                  Add Link
                </Button>
              )}
            </DialogActions>
          </Dialog>

          {/* Alert Dialog */}
          <Dialog
            open={showAlert}
            keepMounted
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            aria-describedby="alert"
          >
            <DialogTitle>{alertTitle}</DialogTitle>
            <DialogContent>
              <div>{alertText}</div>
            </DialogContent>
            <DialogActions>
              <Button onClick={close_alert}>OK</Button>
            </DialogActions>
          </Dialog>

          {/* Loader */}
          {/* <Loader open={showLoader} progress={progress} /> */}
        </div>
      </Dialog>
    </>
  );
}

export default FlnTemplate;
